import { Action, ActionReducer } from '@ngrx/store';
import { createLoadActions, LoadActions } from './actions';
import { createLoadReducer, LoadState } from './reducer';
import { createLoadSelectors, LoadSelectors } from './selectors';
import { GenericEntity, StateAdapter } from '../types';

export interface LoadAdapter<Entity>
  extends StateAdapter<
    LoadActions<Entity>,
    LoadSelectors<Entity>,
    ActionReducer<LoadState<Entity>, Action>,
    LoadState<Entity>
  > {}

export const getDefaultLoadState = <Entity>(): LoadState<Entity> => ({
  primaryKey: 'id',
  loading: false,
  filter: {},
  error: null,
  ids: [],
  entities: {},
});

export function createLoadAdapter<Entity = GenericEntity>(options: {
  stateKey: string;
  type: string;
  primaryKey?: string;
  initialState?: Partial<LoadState<Entity>>;
}): LoadAdapter<Entity> {
  const { type, stateKey, primaryKey = 'id', initialState } = options;
  const hydratedInitialState: LoadState<Entity> = {
    ...getDefaultLoadState<Entity>(),
    primaryKey,
    ...initialState,
  };
  const actions = createLoadActions<Entity>(type);
  const reducer = createLoadReducer<Entity>(hydratedInitialState, actions);
  const selectors = createLoadSelectors<Entity>(stateKey);

  return {
    getActions: () => actions,
    getSelectors: () => selectors,
    getReducer: () => reducer,
    getInitialState: () => hydratedInitialState,
  };
}
